import { useEffect, useState } from "react";
import { createBeerFlight, getBeers } from "../../../services/firestore";
import { Beer, BeerFlight } from "../../../data/types";
import FlightForm from "../FlightForm/FlightForm";
import "./AdminDashboard.scss";
import AddBeer from "../AddBeer/AddBeer";
import SortableBeerList from "../BeerList/SortableBeerList";

interface AdminDashboardProps {
  onLogout: () => void;
}

const AdminDashboard: React.FC<AdminDashboardProps> = (onLogout) => {
  const [beers, setBeers] = useState<Beer[]>([]);
  // const [selectedBeer, setSelectedBeer] = useState<Beer | undefined>();

  useEffect(() => {
    const asyncFunc = async () => {
      const beers = await getBeers();
      setBeers(beers);
    };
    asyncFunc();
  }, []);

  const handleSubmit = async (flight: BeerFlight) => {
    try {
      await createBeerFlight({
        ...flight,
      });
      alert("Beer flight skapad!");
    } catch (err) {
      console.error(err);
      alert("Något gick fel");
    }
  };

  /* const handleSave = (beer: Beer) => {
    setBeers((prev) => {
      const exists = prev.find((b) => b.id === beer.id);
      if (exists) {
        return prev.map((b) => (b.id === beer.id ? beer : b));
      } else {
        return [...prev, beer];
      }
    });
    setSelectedBeer(undefined);
  }; */

  const handleDelete = (id: string) => {
    setBeers((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <div className="admin-dashboard">
      <section className="admin-dashboard__section">
        <h2 className="admin-dashboard__title">Set Today's Beer Flight</h2>
        <FlightForm beers={beers} onSubmit={handleSubmit} />
      </section>

      <section className="admin-dashboard__section">
        <h2 className="admin-dashboard__title">Add Beers</h2>
        <div className="admin-dashboard__beer-add">
          <AddBeer />
        </div>
      </section>

      <section className="admin-dashboard__section">
        <h2 className="admin-dashboard__title">Manage Beers</h2>
        <div className="admin-dashboard__beer-list">
          {/* <BeerList
            beers={beers}
            setBeers={setBeers}
            // onEdit={setSelectedBeer}
            onDelete={handleDelete}
          /> */}
          <SortableBeerList
            beers={beers}
            setBeers={setBeers}
            // onEdit={setSelectedBeer}
            onDelete={handleDelete}
          />
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
